//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import AppSimplifiedHeader from "~/components/AppSimplifiedHeader.vue";
import BRXComponentMethods from '~/helpers/BRXComponentMethods'

export default Vue.extend({
  name: "SimplifiedHeader",
  components: { AppSimplifiedHeader },
  props: {
    component: {},
    page: {},
  },
  methods: {
    getDocument() {
      return BRXComponentMethods.getDocument(this.component, this.page);
    },
    getImage(imageRef) {
      return BRXComponentMethods.getImage(imageRef, this.page);
    },
    extractComponent(data) {
      return BRXComponentMethods.extractComponent(data, this.page, this.properties);
    },
    getData(type) {
      const types = ['placeholder', 'account', 'cart', 'search'];

      if(!this.mappedComponent || types.indexOf(type) === -1) return null;

      if(type === 'placeholder') {
        return this.mappedComponent.placeholder
      }

      const index = this.mappedComponent.items.findIndex(item => item.iconName === type);

      return this.mappedComponent.items[index];

    }
  },
  computed: {
    document() {
      return this.getDocument()
    },
    mappedComponent() {
      if(this.document)
        return this.extractComponent(this.document.getData())
      return null;
    },
  },
})
